import React, { useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'
import { makeKiddomDeleteRequest } from 'infrastructure/api'
import { useNotify } from 'shared/ui/Notify'

const DeleteDuplicateCurriculaButton = ({ schoolID }: { schoolID: number }) => {
  const [open, setOpen] = useState(false)
  const notify = useNotify()
  const refresh = () => {
    window.location.reload()
  }

  const doDelete = async () => {
    try {
      const url = `/v1/kat/schools/${schoolID}/duplicate_curricula`
      const { error } = await makeKiddomDeleteRequest<
        undefined | { error?: unknown }
      >({ kiddomPath: url })
      if (error != null) {
        notify(error, { type: 'error' })
      } else {
        refresh()
      }
    } catch {
      notify('Error occured during api call, contact rostering team', {
        type: 'error',
      })
    }
  }
  const title =
    'You are about to trigger curricula duplicate clean-up, this is a non-reversable action.'
  const buttonText = 'Delete Duplicate Curricula'

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <Button variant="outlined" color="primary" onClick={handleClickOpen}>
        {buttonText}
      </Button>
      <Dialog onClose={handleClose} open={open} data-testid="dialog">
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <span>
              This will search and remove duplicate curricula for the given
              school
            </span>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>No</Button>
          <Button onClick={doDelete}>Yes</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default DeleteDuplicateCurriculaButton
